import {
  Component, OnInit, OnDestroy, Input,
  ChangeDetectorRef
} from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { LicenciaAlertService } from 'app/shared/services/licenciaAlerte.service';

@Component({
  selector: 'app-licencia-alert',
  templateUrl: './licencia-alert.component.html',
  styleUrls: ['./licencia-alert.component.scss'],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('250ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class LicenciaAlertComponent implements OnInit, OnDestroy {

  @Input() empresa: any;
  @Input() variant: 'Light' | 'Dark' | 'Transparent' = 'Light';
  @Input() autoCerrarMs = 3000;
  @Input() diasAviso = 4;

  @Input() menuPosition: 'Side' | 'Top' = 'Side';
  @Input() sidebarCollapsed = false;
  @Input() ocultarSidebar = true;      // hideSidebar del navbar
  @Input() isSmallScreen = false;

  /** se calcula con los inputs anteriores */
  get offsetSidebar(): string {
    // Si el menú está arriba, o el sidebar está oculto/colapsado, no compensamos
    if (this.menuPosition !== 'Side') return '0';
    if (this.isSmallScreen) return '0';
    if (this.ocultarSidebar) return '0';
    return this.sidebarCollapsed ? '70px' : '260px';
  }

  visible = false;
  tipo: 'vencida' | 'porVencer' | null = null;
  mensaje = '';
  private timerId: any;
  private subs = new Subscription();

  constructor(private licenciaAlertService: LicenciaAlertService, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    // Evaluación inicial (por si el componente se monta con datos ya cargados)
    this.evaluarLicencia();

    // Escucha los refrescos que dispara NavigationService
    this.subs.add(
      this.licenciaAlertService.refrescar$.subscribe(() => this.refrescar())
    );

    // Escucha la empresa actualizada que emite NavigationService
    this.subs.add(
      this.licenciaAlertService.empresaActualizada$.subscribe(emp => {
        if (emp) {
          this.empresa = { ...this.empresa, ...emp };
          // No llamamos a evaluar aquí: el servicio también emite 'refrescar$'
          // después de 'empresaActualizada$', así que se evalúa allá.
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  /** Reinicia la alerta: cancela timer, oculta y vuelve a evaluar */
  refrescar(): void {
    this.limpiarTimer();
    this.visible = false;
    this.tipo = null;
    this.mensaje = '';

    // Pequeño delay para que la animación :enter se vuelva a disparar
    setTimeout(() => this.evaluarLicencia(), 50);
  }

  private evaluarLicencia(): void {
    if (!this.empresa?.FechaLicenciaVigencia) return;

    const nomenclatura = this.empresa?.TipoLicencia?.NomenclaturaLicencia;
    if (nomenclatura === 'ILI') return;

    const hoy = moment().startOf('day');
    const vencimiento = moment(this.empresa.FechaLicenciaVigencia).startOf('day');
    const diasRestantes = vencimiento.diff(hoy, 'days');

    console.log('diasRestantes', diasRestantes);

    console.log('diasAviso', this.diasAviso);
    
    if (diasRestantes < 0) {
      this.tipo = 'vencida';
      this.mensaje = `La licencia venció el ${vencimiento.format('DD/MM/YYYY')}. Contacte a su proveedor para renovarla.`;
      this.mostrar();
    } else if (diasRestantes <= this.diasAviso) {      
      this.tipo = 'porVencer';
      this.mensaje = `Su licencia vence en ${diasRestantes} día(s) (${vencimiento.format('DD/MM/YYYY')}). Renuévela a tiempo.`;
      this.mostrar();
    }
    // Si todo OK, no se muestra nada
  }

  private mostrar(): void {
    this.limpiarTimer();              // evita timers huérfanos
    this.visible = true;
    this.timerId = setTimeout(() => this.cerrar(), this.autoCerrarMs);
  }

  cerrar(): void {
    this.visible = false;
    this.limpiarTimer();
    this.cdRef.detectChanges();
  }

  private limpiarTimer(): void {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
}